import { Component, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { FiDialogCloseReason } from '@fi-shared/fi-dialogs/fi-dialogs-close-reason';
import { INameIdObj } from '@fi-shared/fi-shared-interfaces';

@Component({
    selector: 'fi-checklist-report-select-report-dialog',
    template: `
        <div class="checklist-select-report-dialog-content">
          @for (name of data; track name) {
            <div class="report-name">
              <a href (click)="selectReport($event, name)">{{ name.Name }}</a>
            </div>
          }
        </div>
        `,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./checklist-report-select-report-dialog.component.scss'],
    standalone: false,
})
export class ChecklistReportSelectReportDialogComponent extends FiDialogsContentBase<INameIdObj[], INameIdObj> {
    selectReport($event, name: INameIdObj) {
        $event.preventDefault();
        this.dialogRef.close({
            value: name,
            reason: FiDialogCloseReason.YesButton,
        });
    }
}
